import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import type { ApiError, BrowseTrack, Page } from "@touchscreen/api-client";
import { useTouchscreenContext } from "./TouchscreenProvider.js";
import { touchscreenKeys } from "./queryKeys.js";

/**
 * `403 search_disabled` when `venue.search.enabled` is false — check that before calling, same as
 * the old manual fetch. The 300ms-typing debounce is a screen concern: pass the already-debounced
 * query in, not every keystroke, or this fires a request per keystroke.
 */
export function useSearch(
  debouncedQuery: string,
  options?: { enabled?: boolean; perPage?: number },
): UseQueryResult<Page<BrowseTrack>, ApiError> {
  const { client, venue } = useTouchscreenContext();
  const trimmed = debouncedQuery.trim();
  const enabled = (options?.enabled ?? true) && !!venue && trimmed.length > 0;

  return useQuery({
    queryKey: touchscreenKeys.search(venue?.ref ?? "", trimmed),
    queryFn: () => client.search(trimmed, { perPage: options?.perPage ?? 40 }),
    enabled,
  });
}
